<!-- <template>
    <v-card
        elevation="0"
        class="ma-4"
        width="600px"
        height="400px"
        outlined
    >
        <div
            id="header-video"
            class="d-flex justify-center py-4"
        >
            <div class="d-flex mx-2">
                <v-icon class="mr-2" x-large color="red">mdi-youtube</v-icon>
                <h1 class="black--text display-1 font-weight-light">{{ elementVideo.title }}</h1>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="pa-8">
			{{ elementVideo.description }}
		</div>
        <div id="video-content" class="d-flex justify-center">
            <iframe
                frameborder="0"
                border="0"
                cellspacing="0"
                style="border-style: none"
                width="600px"
                allow="fullscreen"
                height="320px"
                :src="elementVideo.url"
            >
            </iframe>
        </div>
    </v-card>
</template> -->

<template>
    <div :class="flipped ? 'flip-container flipped ma-2' : 'flip-container ma-2'">
        <div class="flipper d-flex">
            <div class="front">
                <slot name="front">
                    <VideoFrontCard
                        v-model="flipped"
                        :video="elementVideo"
                    ></VideoFrontCard>
                </slot>
            </div>
            <div class="back" style="height: 100% !important">
                <slot name="back">
                    <VideoBackCard
                        style="height: 100% !important"
                        v-model="flipped"
                        :video="elementVideo"
                    ></VideoBackCard>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
// import ShopAdministrationInfo from './ShopAdministrationInfo'
import VideoBackCard from './VideoBackCard';
import VideoFrontCard from './VideoFrontCard';

export default {
    name: 'VideoCard',
    data: () => ({
        flipped: false,
    }),
    props: {
        elementVideo: {
            type: Object,
            required: true,
        },
    },
    components: {
        VideoBackCard,
        VideoFrontCard,
    },
};
</script>

<style type='text/css' scoped>
i.frontFlipBtn,
i.backFlipBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #ffffff;
}
i.backFlipBtn {
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
    -o-transform: rotateY(-180deg);
    -ms-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
}
.flip-container {
    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -o-perspective: 1000;
    perspective: 1000;
}
.flip-container {
    min-height: 120px;
}
.flipper {
    -moz-transform: perspective(1000px);
    -moz-transform-style: preserve-3d;
    position: relative;
}
.front,
.back {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -o-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: 0.6s;
    -webkit-transform-style: preserve-3d;
    -moz-transition: 0.6s;
    -moz-transform-style: preserve-3d;
    -o-transition: 0.6s;
    -o-transform-style: preserve-3d;
    -ms-transition: 0.6s;
    -ms-transform-style: preserve-3d;
    transition: 0.6s;
    transform-style: preserve-3d;
    top: 0;
    left: 0;
    width: 100%;
}
.back {
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
    -o-transform: rotateY(-180deg);
    -ms-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
    position: absolute;
}
.flip-container.flipped .back {
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    transform: rotateY(0deg);
}
.flip-container.flipped .front {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    transform: rotateY(180deg);
}
.front {
    z-index: 2;
}
</style>
<!-- 
<script>
export default {
    name: 'VideoCard',
    props: {
        elementVideo: {
            type: Object,
            required: true,
        },
    },
    data: () => ({}),
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap');

.vcard-text {
    font-size: 30px;
    font-family: 'Roboto Condensed', sans-serif;
}
</style> -->